import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AswValidators } from '@lib/helpers';

const formGroup = new FormGroup({
  email: new FormControl<string | null>(null, {
    validators: [
      AswValidators.required({
        errorMsgId: 'E0001',
        params: {
          key: 0,
          value: 'label.eMailAddress.passengerInput',
        },
      }),
      AswValidators.email({
        params: {
          key: 0,
          value: 'label.eMailAddress.passengerInput',
        },
      }),
    ],
  }),
  emailConfirm: new FormControl<string | null>(null, {
    validators: [
      AswValidators.required({
        errorMsgId: 'E0001',
        params: {
          key: 0,
          value: 'label.confirmMailAddress',
        },
      }),
      AswValidators.email({
        params: {
          key: 0,
          value: 'label.eMailAddress.passengerInput',
        },
      }),
      confirmEmailValidator(),
    ],
  }),
});

function confirmEmailValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const email = control.root.get('email')?.value;
    const emailConfirm = control.value;

    return email === emailConfirm
      ? null
      : {
          'validate-email': {
            errorMsgId: 'E0461',
            params: {
              key: 0,
              value: 'label.confirmMailAddress',
            },
          } as ValidationErrors,
        };
  };
}

export const createEmailModalForm = () => {
  return formGroup;
};
